/*
 * Scroll-triggered animation observer
 *
 * Watches elements with the class "scroll-trigger" and adds the
 * "scroll-trigger--animate" class when they enter the viewport.
 * Each element animates only once (the observer unobserves after).
 *
 * Gated by: <body data-animate-on-scroll="true">
 */
(function () {
  if (document.body.dataset.animateOnScroll !== 'true') return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-trigger--animate');
          entry.target.classList.remove('scroll-trigger--offscreen');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }
  );

  var targets = document.querySelectorAll('.scroll-trigger');
  targets.forEach(function (target) {
    target.classList.add('scroll-trigger--offscreen');
    observer.observe(target);
  });
})();
